import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useDeleteGym = () => {
  const queryClient = useQueryClient();

  const deleteGym = async (gymId: string) => {
    try {
      console.log("Deleting gym:", gymId);

      // Primero, actualizar los perfiles para desvincularlos del gimnasio
      const { error: profilesError } = await supabase
        .from("profiles")
        .update({ gym_id: null })
        .eq("gym_id", gymId);

      if (profilesError) {
        console.error("Error unlinking profiles:", profilesError);
        throw profilesError;
      }

      // Luego eliminar el gimnasio
      const { error: gymError } = await supabase
        .from("gyms")
        .delete()
        .eq("id", gymId);

      if (gymError) {
        console.error("Error deleting gym:", gymError);
        throw gymError;
      }

      await queryClient.invalidateQueries({ queryKey: ["managerGyms"] });
      toast({
        title: "Gimnasio eliminado",
        description: "El gimnasio ha sido eliminado correctamente.",
      });
    } catch (error: any) {
      console.error("Error deleting gym:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "No se pudo eliminar el gimnasio.",
      });
    }
  };

  return { deleteGym };
};